<mip-modal class="profile-feed" size="full" [noShadow]="true" [position]="isDesktop ? 'relative' : 'fixed'" [class.--is-mobile]="isMobile" [class.--is-desktop]="isDesktop">
  <div class="ad-container" *ngIf="isMobile">
    <mip-ad-mobile-banner #headerAdvertisement adSlotId="profile-mobile-top-ad"></mip-ad-mobile-banner>
  </div>

  <div class="feed-list" [class.--is-desktop]="isDesktop">
    <mip-scroll-fix *ngIf="profile" [top]="isMobile ? 0 : 75" [marginTop]="isMobile ? 0 : 75">
      <mip-profile-top-toolbar [profile]="profile" [backFallbackReferrer]="backFallbackReferrer" [backPathReferrer]="backPathReferrer"></mip-profile-top-toolbar>
    </mip-scroll-fix>

    <!-- [routerLink]=" backPathReferrer ? backPathReferrer.path : '/@' + profile.username" -->
    <!--<div
      class="__close-button-container"
      *ngIf="!hideCloseButton"
    >
      <a
        class="__close-button"
        *ngIf="profile && backPathReferrer"
        mat-icon-button
        [routerLink]="backPathReferrer.path"
      >
        <mip-icon icon="times"></mip-icon>
      </a>

      <a
        *ngIf="profile && !backPathReferrer"
        class="__close-button"
        mat-icon-button
        [routerLink]="'/@' + profile.username"
      >
        <mip-icon icon="times"></mip-icon>
      </a>
    </div>-->

    <!--<div style="position: absolute; z-index: 10; padding: 5px; background: red; color: #FFF;">postsList.length: {{postsList.length}}</div>-->

    <mip-feed-posts
      class="__feed-posts"
      *ngIf="postsList.length"
      [isModal]="true"
      [postsList]="postsList"
      [postCount]="postsList.length"
      [loading]="loadingPosts"
      (onReachedBottom)="getPosts()"
      (onSlideChange)="onSlideChange($event)"
      (onPostAdFill)="onPostAdFill($event)"
      (onPostAdHide)="onPostAdHide($event)"
      (onPostHeaderToggle)="onPostHeaderToggle($event)"
    ></mip-feed-posts>
  </div>
</mip-modal>
